import { createContext } from 'react';
// import { useStateManager } from '../hooks/useStateManager';

const defaultState: any = [];

const MailContext = createContext(defaultState);

export default MailContext;
